import { Card, CardContent } from 'easyship-components';

import { AddShippingInsuranceCard } from '@/components/AddShippingInsuranceCard';
import { ContinueToPaymentButton } from '@/components/ContinueToPaymentButton';
import { CreditCardForm } from '@/components/CreditCardForm';
import { Footer } from '@/components/Footer';
import { OrderDetails } from '@/components/OrderDetails';
import { ShippingInsuranceCard } from '@/components/ShippingInsuranceCard';
import { ShippingInsured } from '@/components/ShippingInsured';
import { usePaymentIntentContext } from '@/providers/PaymentIntentProvider/context';
import { StripeProvider } from '@/providers/StripeProvider';

export const MainPage = () => {
  const {
    data: { is_insured, stripe_payment_intent },
    isThankYouShown,
  } = usePaymentIntentContext();

  return (
    <div className="w-full max-w-[600px] xl:w-[600px] mx-auto mt-3 sm:mt-5 px-4 sm:px-0 flex flex-col items-center gap-8">
      <main>
        <Card className="shadow w-full">
          <CardContent className="p-0">
            {is_insured && isThankYouShown && <ShippingInsured />}
            <OrderDetails />
            <div className="py-3 px-5 flex flex-col gap-3">
              {is_insured ? (
                <ShippingInsuranceCard />
              ) : (
                <>
                  <AddShippingInsuranceCard />
                  {stripe_payment_intent ? (
                    <StripeProvider
                      publishableKey={stripe_payment_intent.stripe_public_key}
                      clientSecret={stripe_payment_intent.client_secret}
                    >
                      <CreditCardForm />
                    </StripeProvider>
                  ) : (
                    <ContinueToPaymentButton />
                  )}
                </>
              )}
            </div>
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  );
};
